import { render, staticRenderFns } from "./CompanyContact.vue?vue&type=template&id=742e6660"
import script from "./CompanyContact.vue?vue&type=script&lang=js"
export * from "./CompanyContact.vue?vue&type=script&lang=js"
import style0 from "./CompanyContact.vue?vue&type=style&index=0&id=742e6660&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports